import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRockClimbingNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.832 6.752L2.584 5.92.92 8.416l1.248.832c.97.647 1.36 2.046.796 3.36-.256.596-.503 1.26-.629 1.867a2.576 2.576 0 00-.01.038L.378 22.307A12.63 12.63 0 000 25.37v1.755C0 33.131 4.869 38 10.875 38c2.353 0 4.643-.763 6.525-2.175l2.997-2.248 22.004 3.321A4.872 4.872 0 0048 32.081c0-2.98-1-5.874-2.842-8.217l-1.485-1.89a15.499 15.499 0 00-3.917-3.533L24.447 8.783a5.5 5.5 0 00-7.793 2.074l-3.965 7.473-1.723-2.585a7.286 7.286 0 00-4.872-3.146c.437-2.142-.258-4.51-2.262-5.846zM8.47 17.409l9.495 14.242-2.365 1.774a7.875 7.875 0 01-12.6-6.3V25.37c0-.787.097-1.571.288-2.335l1.881-7.527a4.286 4.286 0 013.3 1.9zm12.41 13.207l-3.224-4.836 27.145 4.286A10.3 10.3 0 0145 32.081a1.872 1.872 0 01-2.15 1.851zm-5.487-8.23l-.813-1.22 4.724-8.904a2.5 2.5 0 013.542-.942l2.141 1.35-2.6 5.2 2.683 1.343 2.467-4.934 2.772 1.749-2.322 4.643 2.683 1.342 2.188-4.376 5.297 3.342a12.501 12.501 0 013.159 2.849l1.485 1.89c.28.356.535.729.764 1.115z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRockClimbingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRockClimbingNormalLarge;
